/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { isArray } from '@ember/array';
import { action, computed } from '@ember/object';
import { setDiff } from '@ember/object/computed';
import { service } from '@ember/service';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';
import { snapshotFields } from '@linc-technologies/linced-common/utils/record-rollback';

export default class SchoolGroupDialog extends Component {
  @action
  setCurrentTab(value) {
    this.currentTab = value;
  }

  @action
  setLimit(value) {
    this.limit = value;
  }

  @action
  setSchoolsPage(value) {
    this.schoolsPage = value;
  }

  @service
  toaster;

  group = null;
  allSchools = null;
  @tracked
  selectedSchools = [];
  preselectedSchools = null;
  @tracked
  currentTab = 0;
  @tracked
  saveInProgress = false;
  limitOptions = Object.freeze([5, 10, 25, 50, 100]);
  @tracked limit = 10;

  @computed('limit', 'selectedSchools.[]')
  get schoolsPages() {
    let max = Math.max(
      1,
      Math.ceil(this.get('selectedSchools.length') / this.limit),
    );
    let pages = [];
    for (let i = 1; i <= max; i++) {
      pages.push(i);
    }
    return pages;
  }

  @tracked schoolsPage = 1;
  @tracked sortProp = 'name';
  @tracked sortDir = 'asc';

  @computed('schoolsPage', 'limit', 'sortProp', 'sortDir', 'selectedSchools.[]')
  get paginatedSchools() {
    let ind = (this.schoolsPage - 1) * this.limit;
    let schools = sortBy(this.selectedSchools, this.sortProp, 'name');
    if (this.sortDir === 'desc') {
      schools = schools.reverse();
    }

    return schools.splice(ind, this.limit);
  }

  @setDiff('allSchools', 'selectedSchools')
  remainingSchools;

  toggleDialog() {}

  didReceiveAttrs() {
    if (isArray(this.preselectedSchools)) {
      // Component was fed a list of schools to preselect, for a new group.
      this.selectedSchools = this.preselectedSchools.slice();
    } else {
      // No preselected schools - pull from the group's existing schools.
      this.selectedSchools = this.group.schoolsArray.slice();
    }
    super.didReceiveAttrs(...arguments);
  }

  @action
  handleToggleDialog() {
    this.toggleDialog();
  }

  @action
  saveGroup() {
    this.saveInProgress = true;

    const restore = snapshotFields(this.group, ['schoolIds']);
    this.group.set('schoolIds', this.selectedSchools);

    this.group
      .save()
      .then(() => {
        this.toaster.success(`Group ${this.group.name} saved successfully!`);
        this.toggleDialog();
      })
      .catch(() => {
        // Put the schools back (and each school's groups) so the group
        // doesn't keep a membership the server rejected.
        restore();
        this.toaster.error('Failed to save group.');
      })
      .finally(() => {
        this.saveInProgress = false;
      });
  }

  @action
  addSchool(school) {
    this.selectedSchools = [...this.selectedSchools, school];
  }

  @action
  removeSchool(school) {
    this.selectedSchools = this.selectedSchools.filter((s) => s !== school);
  }

  @action
  decrementPage() {
    let page = this.schoolsPage;
    if (page > 1) {
      this.schoolsPage = page - 1;
    }
  }

  @action
  incrementPage() {
    let page = this.schoolsPage;
    let max = this.schoolsPages.reduce(
      (prev, curr) => (curr > prev ? curr : prev),
      0,
    );
    if (page < max) {
      this.schoolsPage = page + 1;
    }
  }
}
